module.exports = __webpack_public_path__ + "static/media/urgent_medicine.a3b9a8c1.svg";